module.exports = __webpack_public_path__ + "static/img/zlb.4ecfb90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zlb.jpg
// module id = +wMO
// module chunks = 1